// import { useEffect, useMemo, useState } from "react";
// import { Marker, useMap } from "react-leaflet";
// import L from "leaflet";
// import markerSvg from "../../src/assets/markers/substation.png";
// import completedMarkerSvg from "../../src/assets/markers/substation-completed.png";

// const CLUSTER_ZOOM_THRESHOLD = 9; // below this zoom -> show district clusters

// function buildClusterIcon(district, activeCount, completedCount) {
//     const total = activeCount + completedCount;
//     const size = total > 20 ? 66 : total > 8 ? 58 : 50;

//     const html = `
//     <div class="district-cluster" style="width:${size}px;height:${size}px;">
//       <div class="district-cluster-badges">
//         ${activeCount > 0
//             ? `<div class="cluster-badge active-badge">
//                  <img src="${markerSvg}" alt="active" />
//                  <span>${activeCount}</span>
//                </div>`
//             : ""
//         }
//         ${completedCount > 0
//             ? `<div class="cluster-badge completed-badge">
//                  <img src="${completedMarkerSvg}" alt="completed" />
//                  <span>${completedCount}</span>
//                </div>`
//             : ""
//         }
//       </div>
//     </div>
//   `;

//     return new L.DivIcon({
//         html,
//         className: "district-cluster-icon",
//         iconSize: [size, size + 18],
//         iconAnchor: [size / 2, size + 18],
//     });
// }

// function DistrictClusterMarkers({
//     projects,
//     projectIcon,
//     completedProjectIcon,
//     markerRefs,
//     onMarkerClick,
// }) {
//     const map = useMap();
//     const [zoom, setZoom] = useState(map.getZoom());
//     const [expandedDistrict, setExpandedDistrict] = useState(null);

//     useEffect(() => {
//         const handleZoom = () => setZoom(map.getZoom());
//         map.on("zoomend", handleZoom);
//         return () => map.off("zoomend", handleZoom);
//     }, [map]);

//     const districtGroups = useMemo(() => {
//         const groups = {};
//         projects.forEach((p) => {
//             const key = p.district_name || p.district || "Unknown";
//             if (!groups[key]) groups[key] = [];
//             groups[key].push(p);
//         });
//         return groups;
//     }, [projects]);

//     // Zoomed in enough overall -> render individual markers as before
//     const showIndividual = zoom >= CLUSTER_ZOOM_THRESHOLD;

//     const markers = [];

//     Object.entries(districtGroups).forEach(([district, group]) => {
//         const isExpanded = showIndividual || expandedDistrict === district;

//         if (isExpanded) {
//             group.forEach((project) => {
//                 markers.push(
//                     <Marker
//                         key={project.id}
//                         icon={project.status === "COMPLETED" ? completedProjectIcon : projectIcon}
//                         ref={(ref) => {
//                             if (ref) markerRefs.current[project.id] = ref;
//                         }}
//                         position={[Number(project.latitude), Number(project.longitude)]}
//                         eventHandlers={{
//                             click: () => onMarkerClick(project),
//                         }}
//                     />
//                 );
//             });
//             return;
//         }

//         // Collapsed district cluster
//         const avgLat =
//             group.reduce((sum, p) => sum + Number(p.latitude), 0) / group.length;
//         const avgLng =
//             group.reduce((sum, p) => sum + Number(p.longitude), 0) / group.length;

//         const activeCount = group.filter((p) => p.status !== "COMPLETED").length;
//         const completedCount = group.filter((p) => p.status === "COMPLETED").length;

//         markers.push(
//             <Marker
//                 key={`cluster-${district}`}
//                 position={[avgLat, avgLng]}
//                 icon={buildClusterIcon(district, activeCount, completedCount)}
//                 eventHandlers={{
//                     click: () => {
//                         setExpandedDistrict(district);
//                         map.flyTo([avgLat, avgLng], CLUSTER_ZOOM_THRESHOLD + 1, {
//                             duration: 1,
//                         });
//                     },
//                 }}
//             />
//         );
//     });

//     return markers;
// }

// export default DistrictClusterMarkers;
import { useEffect, useMemo, useState } from "react";
import { Marker, useMap } from "react-leaflet";
import L from "leaflet";
import markerSvg from "../../src/assets/markers/substation.png";
import completedMarkerSvg from "../../src/assets/markers/substation-completed.png";

const CLUSTER_ZOOM_THRESHOLD = 9; // below this zoom -> show district clusters

// Maharashtra's rough bounding box — matches MapCanvas's maxBounds
const MAHA_BOUNDS = { minLat: 15.4, maxLat: 22.8, minLng: 72.5, maxLng: 80.9 };

function isValidCoord(lat, lng) {
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= MAHA_BOUNDS.minLat &&
    lat <= MAHA_BOUNDS.maxLat &&
    lng >= MAHA_BOUNDS.minLng &&
    lng <= MAHA_BOUNDS.maxLng
  );
}

function buildClusterIcon(district, activeCount, completedCount) {
  const total = activeCount + completedCount;
  const circleSize = total > 20 ? 56 : total > 8 ? 48 : 42;
  const imgSize = Math.round(circleSize * 0.5);

  const badge = (count, bg, icon) => `
    <div style="
      position: relative;
      width: ${circleSize}px;
      height: ${circleSize}px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${bg};
      border: 3px solid rgba(255,255,255,0.9);
      box-shadow: 0 3px 8px rgba(0,0,0,0.4);
      box-sizing: border-box;
    ">
      <img src="${icon}" alt="marker" width="${imgSize}" height="${imgSize}"
        style="width:${imgSize}px;height:${imgSize}px;object-fit:contain;display:block;" />
      <span style="
        position: absolute;
        bottom: -6px;
        right: -6px;
        background: #fff;
        color: #222;
        font-weight: 700;
        font-size: 12px;
        min-width: 22px;
        height: 22px;
        padding: 0 5px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 4px rgba(0,0,0,0.4);
        line-height: 1;
      ">${count}</span>
    </div>
  `;

  const html = `
    <div style="display:flex;flex-direction:column;align-items:center;cursor:pointer;">
      <div style="display:flex;gap:6px;align-items:center;justify-content:center;">
        ${activeCount > 0 ? badge(activeCount, "radial-gradient(circle, #ff9a56 0%, #ff6b6b 70%, #ff4d6d 100%)", markerSvg) : ""}
        ${completedCount > 0 ? badge(completedCount, "radial-gradient(circle, #4dd0a5 0%, #2e9e6b 70%, #1a7a4c 100%)", completedMarkerSvg) : ""}
      </div>

  `;

  const totalWidth =
    (activeCount > 0 ? circleSize : 0) + (completedCount > 0 ? circleSize : 0) + 10;

  return new L.DivIcon({
    html,
    className: "district-cluster-icon", // kept empty/transparent in leaflet, no size dependency
    iconSize: [totalWidth, circleSize + 20],
    iconAnchor: [totalWidth / 2, circleSize + 20],
  });
}

function DistrictClusterMarkers({
  projects,
  projectIcon,
  completedProjectIcon,
  markerRefs,
  onMarkerClick,
}) {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  const [expandedDistrict, setExpandedDistrict] = useState(null);

  useEffect(() => {
    const handleZoom = () => setZoom(map.getZoom());
    map.on("zoomend", handleZoom);
    return () => map.off("zoomend", handleZoom);
  }, [map]);

  // Split out bad/out-of-region coordinates before they touch grouping or centroid math
  const { validProjects, invalidProjects } = useMemo(() => {
    const validProjects = [];
    const invalidProjects = [];

    projects.forEach((p) => {
      const lat = Number(p.latitude);
      const lng = Number(p.longitude);

      if (isValidCoord(lat, lng)) {
        validProjects.push(p);
      } else {
        invalidProjects.push(p);
      }
    });

    return { validProjects, invalidProjects };
  }, [projects]);

  useEffect(() => {
    if (invalidProjects.length > 0) {
      console.warn(
        "Skipping projects with invalid/out-of-Maharashtra coordinates:",
        invalidProjects.map((p) => ({
          id: p.id,
          name: p.name,
          district: p.district_name || p.district,
          lat: p.latitude,
          lng: p.longitude,
        }))
      );
    }
  }, [invalidProjects]);

  const districtGroups = useMemo(() => {
    const groups = {};
    validProjects.forEach((p) => {
      const key = p.district_name || p.district || "Unknown";
      if (!groups[key]) groups[key] = [];
      groups[key].push(p);
    });
    return groups;
  }, [validProjects]);

  const showIndividual = zoom >= CLUSTER_ZOOM_THRESHOLD;
  const markers = [];

  Object.entries(districtGroups).forEach(([district, group]) => {
    const isExpanded = showIndividual || expandedDistrict === district;

    if (isExpanded) {
      group.forEach((project) => {
        markers.push(
          <Marker
            key={project.id}
            icon={project.status === "COMPLETED" ? completedProjectIcon : projectIcon}
            ref={(ref) => {
              if (ref) markerRefs.current[project.id] = ref;
            }}
            position={[Number(project.latitude), Number(project.longitude)]}
            eventHandlers={{
              click: () => onMarkerClick(project),
            }}
          />
        );
      });
      return;
    }

    const avgLat =
      group.reduce((sum, p) => sum + Number(p.latitude), 0) / group.length;
    const avgLng =
      group.reduce((sum, p) => sum + Number(p.longitude), 0) / group.length;

    const activeCount = group.filter((p) => p.status !== "COMPLETED").length;
    const completedCount = group.filter((p) => p.status === "COMPLETED").length;

    markers.push(
      <Marker
        key={`cluster-${district}`}
        position={[avgLat, avgLng]}
        icon={buildClusterIcon(district, activeCount, completedCount)}
        eventHandlers={{
          click: () => {
            setExpandedDistrict(district);
            map.flyTo([avgLat, avgLng], CLUSTER_ZOOM_THRESHOLD + 1, {
              duration: 1,
            });
          },
        }}
      />
    );
  });

  return markers;
}

export default DistrictClusterMarkers;